import { render, staticRenderFns } from "./TransactionItemGroups.vue?vue&type=template&id=22659c95&"
import script from "./TransactionItemGroups.vue?vue&type=script&lang=js&"
export * from "./TransactionItemGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports